import ReservationBusinessTime from "./ReservationBusinessTime";
import ReservationWeekType     from "./ReservationWeekType";

export default class ReservationBusinessTimes {
  constructor(private readonly _list: ReservationBusinessTime[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public toList(): ReservationBusinessTime[] {
    return this.isEmpty() ? [] : this._list;
  }

  public findByWeekType(weekType: ReservationWeekType): ReservationBusinessTime {
    if (this.isEmpty()) return new ReservationBusinessTime();
    const reservationBusinessTime = this._list.find(reservationBusinessTime => reservationBusinessTime.weekType.value === weekType);
    return reservationBusinessTime ? reservationBusinessTime : new ReservationBusinessTime();
  }

  public findIndexByWeekType(weekType: ReservationWeekType): number {
    return this._list.findIndex(reservationBusinessTime => reservationBusinessTime.weekType.value === weekType);
  }

  public replace(target: ReservationBusinessTime): ReservationBusinessTimes {
    if (this.isEmpty()) return new ReservationBusinessTimes();
    const index = this._list.findIndex(reservationBusinessTime => reservationBusinessTime.weekType.value === target.weekType.value);

    if (index === -1) return new ReservationBusinessTimes(this._list);
    this._list.splice(index, 1);
    this._list.push(target);
    return new ReservationBusinessTimes(this._list);
  }
}